<template>
  <el-form class="volumes add-prof-job">
    <el-dialog :title="`Выбрать ${tr[type]}`" :visible.sync="isSelect" append-to-body
               width="400px">
      <div class="jobs-ul">
        <div
          class="jobs-li" v-for="(job, index) in list" :key="index" @click="() => add(job)"
        >
          <span>{{ job.name }}</span>
        </div>
      </div>
    </el-dialog>
    <div class="volumes">
      <div class="remove-row-container">
      <i class="el-icon-close" v-if="!approve" @click="removeReportClick"></i>
      </div>
      <div class="jobs-ul">

        <el-button :disabled="approve" size="small" class="add" type="primary" style="width: 100%; margin-bottom: 10px"
                   @click="isSelect = !isSelect">
          + Выбрать {{ tr[type] }}
        </el-button>
        <div style="display: flex; justify-content: flex-start">
        </div>
        <div class="jobs-li" v-for="(job, index) in form.jobs" :key="index">

          <div style="display: flex; justify-content: space-between; flex: 1; width: 100%">
            <div>
              <div class="flex" style="justify-content: flex-start; margin-bottom: 2px">
                <strong>{{ job.name || job.label || (job.job && job.job.name) }}</strong>
              </div>
            </div>

            <div class="flex align">
              <div>
              </div>
              <i class="el-icon-close"  v-if="!approve" style="margin-left: 10px" @click="remove(index)"/>
            </div>
          </div>
          <el-row>

            <el-col :span="$store.state.project.available_reports.PROF_TIME ? 12: 24">
              <el-input
                @input="() => {
                 if(!job.time) {
                   job.time = timeProfGlobal.value
                 }
                }"
                :disabled="approve" size="small"  :placeholder="type === 'PROF' ? 'Чел' : 'Кол-во'" type="number" v-model="job.value"/>
            </el-col>
            <el-col v-if="$store.state.project.available_reports.PROF_TIME" :span="12">
              <el-input :disabled="approve" size="small" placeholder="Часы" type="number" v-model="job.time"/>
            </el-col>
          </el-row>
        </div>

        <div style="margin-top: 20px" class="add-prof-filter">
          <filter-select
            :disabled="approve"
            v-model="form.work_type_dir"
            @input="() => form.work_type = null"
            v-if="$store.state.project.work_dir"
            :options="options_dirs" label="Раздел работ" style="margin-bottom: 0;"
          />
          <filter-select
            :disabled="approve"
            @input="selectWorkType"
            v-if="!$store.state.project.work_type_ignore" label="Вид работы" style="margin-bottom: 28px; margin-top: 0"
            :options="getWorks(form.work_type_dir)"
            v-model="form.work_type"/>

        </div>
      </div>
    </div>
  </el-form>
</template>

<script>

import firebase from "firebase";
import {getCurrentMonth} from "../../../../utils/date";
import FilterSelect from "../../../../components/FilterSelect";
import {toFloat} from "../../../../utils/numberUtils";
import {getDirOptions} from "../../../../firestore/dirs";
import {orderBy} from "lodash";

export default {
  name: "AddJobsProf",
  inject: ['timeProfGlobal'],
  components: {FilterSelect},
  props: {
    approve: Boolean,
    value: {},
    workTypeOptions: {type: [Object, Array], default: () => ([])},
    jobName: "",
    type: {
      type: String,
      default: 'PROF'
    },
  },
  data() {
    return {
      dialogObject: false,
      options_dirs: [],
      isSelect: false,
      lock: false,
      list: [],
      form: {
        jobs: [],
        work_type: null,
        work_type_dir: null,
      },
      tr: {
        PROF: 'профессию',
        TECH: 'технику',
      },
      tra: {
        PROF: 'профессий',
        TECH: 'техники',
      },
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(form) {
        if(!this.lock) {
          console.log('FOOOOORM', form)
          this.$emit('input', form)
        }
      }
    }
  },

  methods: {
    async removeReportClick() {
      this.$emit('remove', {
        structureObj: this.structureObj,
        editIndex: this.editIndex
      })

      this.dialogObject = false;
    },
    selectWorkType() {
      this.form.work_type_dir = this.form.work_type_dir || this.options_dirs.find(({value}) => (this.form.work_type && this.form.work_type.data && (this.form.work_type.data.dir === value)))

    },
    open(job = null, index, id, obj) {
      this.structureObj = id
      this.editIndex = index;
      this.dialogObject = true
      this.selectWorkType()
    },
    getWorks(id) {
      if (!id || !id.value) {
        return this.workTypeOptions
      }

      return this.workTypeOptions.filter(({data}) => data.dir === id.value);
    },
    add(job) {
      this.form.jobs.push({
        ...job._data,
        plan: job._data.plan || '',
        value: '',
        time: '',
      });
      this.isSelect = false;
    },
    remove(index) {
      const result = [...this.form.jobs];
      result.splice(index, 1)
      this.form.jobs = [...result];
    }
  },
  async mounted() {
    this.form = JSON.parse(JSON.stringify(this.value));

    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).collection('jobs')
      .where('type', '==', this.type).get()
      .then((data) => {
        const result = []
        data.forEach((subDoc) => {
          const data = subDoc.data()
          result.push({
            name: data.name,
            plan: data.plan,
            id: subDoc.id,
            _data: data
          })
        })

        // console.log(!this.result.length, 'this.result')
        if ((!this.result || !this.result.length) &&  !this.form.jobs.length && this.type === 'PROF') {
          // const worker = result.find((j) => j.name === 'Рабочие')
          // if (worker) {
          //   this.add(worker)
          // }

          const worker = result.find((j) => j.name === 'Рабочие')
          if(this.$store.state.project.available_reports.PROF_ALL) {
            const resultJobs = orderBy(result, 'index', ['asc'])
            resultJobs.forEach((r) => {
              this.add(r)
            })

          } else if (worker) {
            this.add(worker)
          }
        }



        this.list = result;
      });

    this.options_dirs = await getDirOptions(this.$store.state.project.id);
    // this.lock = false
    this.selectWorkType()
  },
  computed: {
    total() {
      let result = 0;

      this.form.jobs.forEach(({plan}) => {
        result += plan || 0
      })

      return result
    },
    value1() {
      let result = 0;

      this.form.jobs.forEach(({value}) => {
        result += Number(value || 0)
      })

      return result
    },
    time() {
      let result = 0;

      this.form.jobs.forEach(({time}) => {
        result += time || 0
      })

      return result
    },
    currentMonth() {
      return getCurrentMonth(this.$route.query.name)
    }
  }
}
</script>

<style scoped lang="scss">

.add-prof-job {
  width: calc(100% - 42px);
}

.fa-edit {
  font-size: 18px;
  width: 100px;
}

.volumes {
  max-width: 95%;
  margin-left: 8px;
}

.create-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
}

.jobs-li {
  justify-content: center;
  min-height: 36px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  text-align: left;
  align-items: flex-start;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);

  &.pick {
    padding-bottom: 8px !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    align-items: center;
  }

  &:hover {
    background: #eee;
  }

  &:last-child {
    border-bottom: none;
  }
}

.add-prof-job {
  padding: 5px 15px;
  margin-bottom: 10px;
  background: #f7f7f7;
  box-shadow: 0px 0px 8px 0px #ccc;
  border-radius: 5px;
}

.remove-row-container {
 display: flex;
  justify-content: flex-end;
  height: 32px;
  align-items: center;

  .el-icon-close {
    cursor: pointer;
    font-size: 20px;
  }
}
</style>
<style lang="scss">
.volumes .el-dialog {
  max-width: 100% !important;
}

input::placeholder {
  color: #888 !important;
}

.add-prof-filter {
  .el-form-item {
    margin-bottom: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/AddJobsProf.vue